var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavSubjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 12.5H12.5C13.8807 12.5 15 13.6193 15 15C15 16.3807 13.8807 17.5 12.5 17.5H3.33332M3.33332 12.5V17.5M3.33332 12.5H1.66666M3.33332 17.5H1.66666M3.33332 2.5H12.5C13.8807 2.5 15 3.61929 15 5C15 6.38071 13.8807 7.5 12.5 7.5H3.33332M3.33332 2.5V7.5M3.33332 2.5H1.66666M3.33332 7.5H1.66666M16.6667 7.5H7.49999C6.11928 7.5 4.99999 8.61929 4.99999 10C4.99999 11.3807 6.11928 12.5 7.49999 12.5H16.6667M16.6667 7.5V12.5M16.6667 7.5H18.3333M16.6667 12.5H18.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavSubjects);
export default __webpack_public_path__ + "static/media/sidenav-subjects.8d0f7ed036e67350e06ce33ceb21b436.svg";
export { ForwardRef as ReactComponent };